import styled from 'styled-components';

import { Flex } from '@amzn/storm-ui';

export const BulkBarContainer = styled(Flex)`
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
  border: 1px solid #d5dbdb;
  border-radius: 4px;
  background-color: #f7fafa;
`;

export const BulkBarText = styled.span`
  font-weight: 700;
`;

export const BulkBarSelect = styled.select`
  min-width: 12rem;
  padding: 0.35rem 0.5rem;
  border: 1px solid #879596;
  border-radius: 4px;
`;
